import { useEffect, useState } from 'react';
import axios from 'axios';
import { getSettingsParam, setSettingsParam } from '../../api/account';

const BANNERS_VIEWED_KEY = 'topBannersViewed';

export default function useBannerState(): [
  (string | number)[],
  (v: number | string) => Promise<void>,
  boolean
] {
  const [bannersViewedState, setBannersViewedState] = useState<
    (string | number)[]
  >([]);
  const [processing, setProcessing] = useState(true);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setProcessing(true);
    try {
      const r = await getSettingsParam(BANNERS_VIEWED_KEY);
      const data = JSON.parse(r.value);
      setBannersViewedState(data);
    } catch (e) {
      if (e instanceof axios.AxiosError && e.response?.status === 404) {
        await setSettingsParam(BANNERS_VIEWED_KEY, JSON.stringify([]));
        setBannersViewedState([]);
      }
      console.log(e);
    }
    setProcessing(false);
  };

  const setBannerViewed = async (id: string | number) => {
    const valueSet = new Set(bannersViewedState);
    valueSet.add(id);
    try {
      await setSettingsParam(
        BANNERS_VIEWED_KEY,
        JSON.stringify(Array.from(valueSet))
      );
      getData();
    } catch (e) {
      console.log(e);
    }
  };

  return [bannersViewedState, setBannerViewed, processing];
}
